// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Overlay-absolute-center","overlay":"onfido-sdk-ui-Overlay-overlay","rectangle":"onfido-sdk-ui-Overlay-rectangle","face":"onfido-sdk-ui-Overlay-face","isWithoutHole":"onfido-sdk-ui-Overlay-isWithoutHole"};


//////////////////
// WEBPACK FOOTER
// ./components/Overlay/style.css
// module id = 379
// module chunks = 1